import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";

import WithAppLayout from "../../../components/WithAppLayout";
import PageTableWithSearch from "../../../components/PageTableWithSearch/PageTableWithSearch";
import JobContactEmailFilter from "../../../components/JobContactEmailFilter";

import { jobsColumns } from "../../../components/PageTableWithSearch/tableDataHelper";
import { ARCHIVED_JOBS_QUERY } from "../../../graphql/jobs";
import { JOB_DETAILS_PATH } from "../../../routes";
import __ from "../../../helpers/translations"

function ArchivedJobsPage({ currentUser }) {
  const navigate = useNavigate();

  const [contactEmail, setContactEmail] = useState(null);

  const { data, loading } = useQuery(ARCHIVED_JOBS_QUERY, {
    variables: { contactEmail: contactEmail || null },
    fetchPolicy: "network-only",
  });

  const agencyType = currentUser?.agency?.type;
  const jobs = data?.agencyArchivedJobs || [];

  return (
    <PageTableWithSearch
      title={`${__("Archived", agencyType)} Jobs ${
        jobs.length ? ` (${jobs.length})` : ""
      }`}
      tableId="agency-archived-jobs"
      columns={jobsColumns}
      data={jobs}
      loading={loading}
      filterControls={
        <JobContactEmailFilter
          value={contactEmail}
          onChange={setContactEmail}
          currentUserEmail={currentUser?.email}
        />
      }
      onClickRow={(moblyzeJob) => {
        navigate(JOB_DETAILS_PATH.replace(":id", moblyzeJob.id));
      }}
    />
  );
}

export default WithAppLayout(ArchivedJobsPage);
